export const processData = [
  {
    icon: {
      src: "/assets/icons/process1.png",
      alt: "process1",
    },
    heading: "Proefrit",
    description:
      "Wij maken altijd een rit met de auto, dit doen wij om na te gaan hoe de auto rijdt en hoe deze reageert.",
    classes: {
      desktop:
        "lg:top-[6%] lg:left-[330px] lg:w-[450px] 2xl:top-[9%] 2xl:left-[600px] 2xl:w-[600px]",
      tablet: "md:top-[10%] md:left-[230px] md:w-[300px]",
      // mobile: "sm:top-[12%] sm:left-[100px] sm:w-[200px]",
      mobile: "top-[9%] left-[100px] w-[250px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process2.png",
      alt: "process2",
    },
    heading: "Controle",
    description:
      "De auto wordt uitgelezen, eventuele storingen worden altijd besproken!",
    classes: {
      desktop:
        "lg:top-[13%] lg:left-[350px] lg:w-[400px] 2xl:top-[15%] 2xl:left-[600px] 2xl:w-[600px]",
      tablet: "md:top-[18%] md:left-[300px] md:w-[280px]",
      mobile: "top-[19%] left-[180px] w-[250px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process3.png",
      alt: "process3",
    },
    heading: "Uitlezen software",
    description: "De originele software van uw auto wordt uitgelezen.",
    classes: {
      desktop:
        "lg:top-[23%] lg:right-[300px] lg:w-[400px] 2xl:top-[25.7%] 2xl:right-[600px] 2xl:w-[600px]",
      tablet: "md:top-[28%] md:right-[200px] md:w-[280px]",
      mobile: "top-[31.5%] right-[155px] w-[280px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process4.png",
      alt: "process4",
    },
    heading: "Software schrijven",
    description: "De originele software wordt geheel op maat herschreven.",
    classes: {
      desktop:
        "lg:top-[33.7%] lg:left-[400px] lg:w-[400px] 2xl:top-[35.8%] 2xl:left-[600px] 2xl:w-[600px]",
      tablet: "md:top-[38%] md:left-[230px] md:w-[280px]",
      mobile: "top-[40.2%] left-[190px] w-[267px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process5.png",
      alt: "process5",
    },
    heading: "Terugschrijven software",
    description: "De herschreven software wordt terug geplaatst.",
    classes: {
      desktop:
        "lg:top-[44%] lg:right-[250px] lg:w-[400px] 2xl:top-[45.5%] 2xl:right-[400px] 2xl:w-[600px]",
      tablet: "md:top-[48%] md:right-[200px] md:w-[350px]",
      mobile: "top-[49.5%] right-[140px] w-[280px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process6.png",
      alt: "process6",
    },
    heading: "Nacontrole",
    description: "De auto wordt opnieuw uitgelezen.",
    classes: {
      desktop:
        "lg:top-[55%] lg:left-[350px] lg:w-[400px] 2xl:top-[56.5%] 2xl:left-[420px] 2xl:w-[600px]",
      tablet: "md:top-[58%] md:left-[250px] md:w-[280px]",
      mobile: "top-[59%] left-[140px] w-[200px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process7.png",
      alt: "process7",
    },
    heading: "Testrit",
    description: "Wij maken een testrit op de openbare weg.",
    classes: {
      desktop:
        "lg:top-[66%] lg:right-[300px] lg:w-[400px] 2xl:top-[67%] 2xl:right-[330px] 2xl:w-[400px]",
      tablet: "md:top-[68%] md:right-[200px] md:w-[280px]",
      mobile: "top-[68.5%] right-[150px] w-[200px]",
    },
  },
  {
    icon: {
      src: "/assets/icons/process8.png",
      alt: "process8",
    },
    heading: "Testrit met de klant",
    description: "Wij maken samen met u een testrit op de openbare weg.",
    classes: {
      desktop:
        "lg:top-[74.8%] lg:left-[130px] lg:w-[400px] 2xl:top-[75.8%] 2xl:left-[130px] 2xl:w-[600px]",
      tablet: "md:top-[78%] md:left-[100px] md:w-[280px]",
      mobile: "top-[78.5%] left-[50px] w-[240px]",
    },
  },
];
